import React from "react";

import { Card, Message } from "semantic-ui-react";
import ReportListItem from "./ReportListItem";

import { reportContext } from "contexts/ReportContext";

function ReportDisplay() {
	// const reportData = useContext(reportContext);
	// console.log({ reportData });
	return (
		<reportContext.Consumer>
			{({ filteredReportList }) =>
				filteredReportList.length ? (
					<Card.Group itemsPerRow={3}>
						{filteredReportList.map((item) => (
							<ReportListItem key={item._id} record={item} />
						))}
					</Card.Group>
				) : (
					<Message content="Filter didn't match any record." />
				)
			}
		</reportContext.Consumer>
	);
}

export default ReportDisplay;
